import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Icon from '../common/Icon';

const UploadSection = ({ isAppDefinitionLoaded, appDefinitionFile, onFileLoadHandler }) => (
    <>
        <h3 className="sideloaded-upload-section__header">App Manifest</h3>
        <div className="sideloaded-upload-section">
            {isAppDefinitionLoaded ? (
                <p className="sideloaded-filename">
                    <Icon alias="file" />
                    {appDefinitionFile.name}
                </p>
            ) : (
                <p className="sideloaded-filename-placeholder">Select JSON file with app manifest...</p>
            )}
            <label htmlFor="selectFileInput" className="sg-button-link sideloaded-select-file-btn">
                <Icon alias="upload" />
                Select file
            </label>
            <input id="selectFileInput" className="fileInput" type="file" accept=".json" onChange={onFileLoadHandler} />
        </div>
    </>
);

UploadSection.propTypes = {
    isAppDefinitionLoaded: PropTypes.bool.isRequired,
    appDefinitionFile: PropTypes.object,
    onFileLoadHandler: PropTypes.func.isRequired,
};

export default UploadSection;
